import { render, staticRenderFns } from "./AfterSalesOrders.vue?vue&type=template&id=70a96a44&scoped=true&"
import script from "./AfterSalesOrders.vue?vue&type=script&lang=js&"
export * from "./AfterSalesOrders.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesOrders.vue?vue&type=style&index=0&id=70a96a44&scoped=true&lang=css&"
import style1 from "./AfterSalesOrders.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a96a44",
  null
  
)

export default component.exports